import { useContext } from 'react';
import CardsContext from '../context/CardsContext';

export const useCards = () => {
    const context = useContext(CardsContext);
    if (context === undefined) {
        throw new Error('useCards must be used within a CardsProvider');
    }
    return context;
};

// Hook to get translated card information
export const useTranslatedCard = (cardId: number) => {
    const { getTranslatedCard } = useCards();
    const translatedCard = getTranslatedCard(cardId);
    return translatedCard;
};

// Default export for backward compatibility
export default useCards;
